import React, { useState } from "react";
import { BaseContext } from "./basepath";

const BasepathContextProvider = ({ children }) => {
  const [basepath, setBasepath] = useState(false);

  const changeBasePath = (path) => {
    setBasepath(path);
  };

  const contextValue = {
    basepath,
    changeBasePath,
  };

  return (
    <BaseContext.Provider value={contextValue}>{children}</BaseContext.Provider>
  );
};

export default BasepathContextProvider;
